import { FC } from "react";
import useEvent from "react-use-event-hook";

import { PIC } from "@ryde/assets";
import { CHECKBOX_DEFAULT_SIZE } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { CheckboxStarContainer } from "./checkboxes.styled";

interface ICheckboxStar {
  width?: number;
  height?: number;
  checked: boolean;
  strokeColor?: string;
  onCheckboxToggle?: () => void;
}

export const CheckboxStar: FC<ICheckboxStar> = ({
  checked,
  onCheckboxToggle,
  width = CHECKBOX_DEFAULT_SIZE,
  height = CHECKBOX_DEFAULT_SIZE,
  strokeColor = rydeColors.grey,
}) => {
  const toggleChecked = useEvent((): void => {
    onCheckboxToggle?.();
  });
  const color = checked ? rydeColors.yellow : rydeColors.lightGreyBorder;
  const border = checked ? rydeColors.yellow : strokeColor;
  return (
    <CheckboxStarContainer
      data-e2e-value={checked ? "checked" : "unchecked"}
      width={width}
      height={height}
    >
      <PIC.TableStarSvg
        fill={color}
        stroke={border}
        onClick={toggleChecked}
        width={width}
        height={height}
        data-e2e="svg-star"
        className="star_icon"
      />
    </CheckboxStarContainer>
  );
};
